export default {
  processing: 'Processing query',
};
